<template>
  <drag-modal :visible="$store.state.dislog.beforestart" @cancel="reset" :title="'添加进度-' + litetit"
    :class="{ editbox: Edit }" width="860px">
    <div class="navbox" v-if="Edit">
      <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit"></Nscroll>
      <div class="intopbtn" v-if="!isAllDis">
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
          <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
        </a-popconfirm> -->
        <a-button icon="edit" v-if="
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) &&
          $store.getters.publicPower
        " style="margin-left: 10px" @click="openEdit = !openEdit">{{ openEdit ? '修改' : '取消修改' }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <a-form-model-item label="操作人" prop="actor" :rules="{
            required: true,
            message: '请输入操作人',
            trigger: 'blur',
          }" :wrapper-col="{ span: 10 }">
            <a-input v-model="form.actor" placeholder="请输入操作人" :disabled="openEdit" />
          </a-form-model-item>
          <a-form-model-item label="操作时间" prop="act_time" :rules="{
            required: true,
            message: '请选择操作时间',
            trigger: 'change',
          }" :wrapper-col="{ span: 10 }">
            <a-date-picker v-model="form.act_time" placeholder="请选择操作时间" format="YYYY-MM-DD" type="date"
              valueFormat="YYYY-MM-DD HH:mm:ss" :disabled="openEdit" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="comment" :rules="{
            required: false,
            message: '请输入备注',
            trigger: 'change',
          }" v-if="!loading">
            <Textarea :content="form.comment" @contentVal="
              (element) => {
                form.comment = element
              }
            " :edit="openEdit" :keyArr="['time', 'user']">
            </Textarea>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top: 20px">
            <Upload :fList="form.files" @upFileAfter="
              (element) => {
                form.files = element
              }
            " :edit="openEdit" v-if="!loading" :Wid='"102px"' />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width: 148px"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="
                margin-left: 20px;
                width: 148px;
                background: #b2c9e1;
                color: #fff;
              " @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>
</template>
<script>
const formItem = {
  actor: '',
  act_time: '',
  comment: [{}],
  files: [],
}
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import { mapGetters, mapActions } from 'vuex'
import { ssclzbAdd, ssclzbEdit, ssclzbLists } from '@/server/speed'
import Textarea from '@/components/textarea'
export default {
  name: 'Beforestart',
  computed: {
    ...mapGetters(['litetit', 'Edit']),
  },
  components: {
    Textarea,
    Upload,
    Nscroll,
  },
  data() {
    return {
      isAllDis: this.$route.query.t,
      form: JSON.parse(JSON.stringify(formItem)),
      step: this.$store.state.StepLite,
      rules: {},
      loading: true,
      openEdit: false,
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        ssclzbLists({
          cause_id: this.$store.state.cause.id,
          step: this.step,
        }).then((e) => {
          e.list.map((ele) => {
            ele.ssclzb.comment =
              !ele.ssclzb.comment ||
                (ele.ssclzb.comment && ele.ssclzb.comment.length == 0)
                ? [{}]
                : ele.ssclzb.comment;
          })
          this.$store.dispatch("settime", e.list[0].ssclzb.update_time)
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
        })
        this.openEdit = true
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    async copydel(index) {
      //删除进度
      await this.Newdel({
        index: index,
        formKey: ['act_time', 'actor', 'comment'],
        valkey: 'ssclzb',
      }).then((e) => {
        this.form = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0
              ? true
              : false //当前是否是在修改下的新增
          if (form.files && form.files.length > 0) {
            form.files = form.files.map((ele) => {
              return ele.upload_id || ele
            })
          }
          form.comment = form.comment.filter(ele => { return ele.content })
          form.step = this.step
          if (this.Edit && !isEditCopyAdd) {
            //修改
            let step_id = this.$store.state.DisForm.infoList[curIndex].ssclzb.id
            form.id = step_id
            ssclzbEdit(form).then((e) => {
              this.$message.success({ content: '修改成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.openEdit = true
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            ssclzbAdd(form).then((e) => {
              this.$message.success({ content: '新增成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async see(index) {
      //查看切换 审批
      this.loading = true
      this.seeInfo({
        index: index,
        formKey: ['act_time', 'actor', 'comment'],
        valkey: 'ssclzb',
      }).then((e) => {
        // console.log(e)
        this.form = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    reset() {
      this.reMove().then((e) => {
        this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', { key: 'beforestart', by: false })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  },
}
</script>
